module.exports = __webpack_public_path__ + "img/banner.ca85f7bf.png";